import { InternalAxiosRequestConfig } from 'axios'
import Cookies from 'js-cookie'

import { COOKIES_KEYS } from '../constants/cookiesKeys'

export class RequestInterceptors {
  private config: InternalAxiosRequestConfig

  constructor(config: InternalAxiosRequestConfig) {
    this.config = config
  }

  stringifyParams = () => {
    if (this.config.params && typeof this.config.params === 'object') {
      const stringifiedParams: Record<string, string> = {}

      Object.keys(this.config.params).forEach((key) => {
        const value = this.config.params[key]
        stringifiedParams[key] =
          typeof value === 'object' ? JSON.stringify(value) : String(value)
      })

      this.config.params = stringifiedParams
    }

    return this
  }

  setTokenHeader() {
    this.config.headers['locale'] = navigator.language
    this.config.headers['Authorization'] =
      'Bearer ' + Cookies.get(COOKIES_KEYS.token)

    return this
  }

  build() {
    return this.config
  }
}
